// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  input,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizedDatePipe } from '../../shared/pipes/localizedDate.pipe';
import { ClipboardService } from '../../shared/services/clipboard.service';
import { PartStatusInfoComponent } from '../part-status-info/part-status-info.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SpTicketModel } from '../interfaces/sp-ticket-model';
import { SubtableComponent } from '../subtable/subtable.component';
import { SubTableHeader } from '../interfaces/sp-subtable-headers';
import { SpSortEventModel } from '../model/sp-sort-event-model';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    LocalizedDatePipe,
    MatTooltipModule,
    PartStatusInfoComponent,
    SubtableComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-service-tickets-table-desktop',
  templateUrl: './service-tickets-table-desktop.component.html',
  styleUrl: './service-tickets-table-desktop.component.scss',
})
export class ServiceTicketsTableDesktopComponent {
  tickets = input<SpTicketModel[]>([]);
  sortChange = output<SpSortEventModel>();

  protected readonly clipboardService = inject(ClipboardService);

  protected readonly UNKNOWN = 'Unknown';

  public headersSubtable: SubTableHeader[] = [
    {
      label: 'spareParts.partNumber',
      key: 'partNumber',
    },
    {
      label: 'spareParts.partDescription',
      key: 'partDescription',
    },
    {
      label: 'spareParts.consumedDate',
      key: 'consumedDate',
    },
    {
      label: 'spareParts.partStatus',
      key: 'partStatus',
    },
  ];

  protected hasOverflow = (element: HTMLElement): boolean => {
    return element.scrollWidth > element.clientWidth;
  };

  protected toggleSort(property: string, isDescending: boolean): void {
    this.sortChange.emit({ property, isDescending });
  }
}
